import { map } from 'lodash/fp';
import { ProductPricingDiscriminator } from '@mews/enums';
import { Option } from '@mews-commander/legacy-data-structures';
import { store } from '@mews-commander/legacy-app-instance';
import { useLocalizeProperty } from '@mews/framework';
import { getProductChargingLocalization, getProductPostingLocalization } from '../selectors/products';
import AbsoluteProductOptionsText from './AbsoluteProductOptionsText';
import RelativeProductOptionsText from './RelativeProductOptionsText';

export const mapProductOptions = (
    isMultiTaxEnvironment: $TSFixMe,
    prices = {},
    localizeProperty: ReturnType<typeof useLocalizeProperty>
) =>
    map(({ id, names, pricing }) => {
        const state = store().getState();
        const isRelative = pricing.discriminator === ProductPricingDiscriminator.Relative;
        const pricingValue = pricing.value;

        let textKey;
        let timeText;

        if (isRelative) {
            const { perTimeUnitText, textKey: postingModeTextKey } = getProductPostingLocalization(state, { id });

            textKey = postingModeTextKey;
            timeText = perTimeUnitText;
        } else {
            const { perTimeUnitText, textKey: chargingModeTextKey } = getProductChargingLocalization(state, { id });

            textKey = chargingModeTextKey;
            timeText = perTimeUnitText;
        }

        const priceObject = isMultiTaxEnvironment ? { ...pricingValue, value: pricingValue.netValue } : pricingValue;
        // @ts-expect-error $TSFixMeError: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{}'.
        const { minPrice, maxPrice } = prices[id] || {};

        const secondaryText = isRelative ? (
            <RelativeProductOptionsText
                percentage={pricing.value.multiplier}
                // @ts-expect-error $TSFixMeError: Type 'TextKey | null' is not assignable to type 'TextKey'.
                textKey={textKey}
                substitutes={{ timeUnit: timeText }}
            />
        ) : (
            <AbsoluteProductOptionsText
                // @ts-expect-error $TSFixMeError: Type 'TextKey | null' is not assignable to type 'TextKey'.
                textKey={textKey}
                maxPrice={maxPrice}
                minPrice={minPrice}
                price={priceObject}
                substitutes={{ timeUnit: timeText }}
                isMultiTaxEnvironment={isMultiTaxEnvironment}
            />
        );

        return Option({
            value: id,
            label: localizeProperty(names),
            secondaryText,
        });
    });
